module.exports = __webpack_public_path__ + "static/bower-logo.fc0f31b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/bower-logo.png
// module id = 1141
// module chunks = 35783957827783